var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExportLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.80313 7.13806L9.99839 2.9428V5.33332H11.3317V0.666656H6.66506V1.99999H9.05558L4.86032 6.19525L5.80313 7.13806Z",
  fill: "#636766"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.667 9.99999V7.33332H9.33366V9.99999H2.00033V2.66666H4.66699V1.33332H2.00033C1.26395 1.33332 0.666992 1.93028 0.666992 2.66666V9.99999C0.666992 10.7364 1.26395 11.3333 2.00033 11.3333H9.33366C10.07 11.3333 10.667 10.7364 10.667 9.99999Z",
  fill: "#636766"
})));
export { SvgExportLogo as ReactComponent };
export default __webpack_public_path__ + "b8fa9105c3c8e14a5696e4c23b47250c.svg";